module.exports = __webpack_public_path__ + "static/img/280319.995ffa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/280319.png
// module id = lGea
// module chunks = 0